"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
var react_1 = __importDefault(require("react"));
var Layout_module_scss_1 = __importDefault(require("./Layout.module.scss"));
var react_redux_1 = require("react-redux");
var usePageTitle_1 = require("../../hook/usePageTitle");
var antd_1 = require("antd");
var menu_1 = __importDefault(require("antd/es/menu"));
var icons_1 = require("@ant-design/icons");
var react_router_dom_1 = require("react-router-dom");
var adminSlice_1 = require("../../redux/slice/adminSlice");
var useLoad_1 = require("../../hook/useLoad");
var Header = antd_1.Layout.Header, Content = antd_1.Layout.Content;
var Layout = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var location = (0, react_router_dom_1.useLocation)();
    (0, useLoad_1.useLoad)();
    (0, usePageTitle_1.usePageTitle)();
    var items = [
        {
            label: react_1.default.createElement(react_router_dom_1.Link, { to: "/admin/cars" }, "\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438"),
            key: '/admin/cars',
            icon: react_1.default.createElement(icons_1.CarOutlined, null),
        },
        {
            label: react_1.default.createElement(react_router_dom_1.Link, { to: "/admin/add_car" }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0430\u0432\u0442\u043E"),
            key: '/admin/add_car',
            icon: react_1.default.createElement(icons_1.PlusCircleOutlined, null),
        },
        {
            label: react_1.default.createElement(react_router_dom_1.Link, { to: "/admin/categories" }, "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438"),
            key: '/admin/categories',
            icon: react_1.default.createElement(icons_1.AppstoreOutlined, null),
        },
        {
            label: react_1.default.createElement(react_router_dom_1.Link, { to: "/admin/banks" }, "\u0411\u0430\u043D\u043A\u0438"),
            key: '/admin/banks',
            icon: react_1.default.createElement(icons_1.BankOutlined, null),
        },
        {
            label: react_1.default.createElement(react_router_dom_1.Link, { to: "/admin/programs" }, "\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B"),
            key: '/admin/programs',
            icon: react_1.default.createElement(icons_1.FileProtectOutlined, null),
        },
        {
            label: react_1.default.createElement(react_router_dom_1.Link, { to: "/admin/contacts" }, "\u0417\u0430\u044F\u0432\u043A\u0438"),
            key: '/admin/orders',
            icon: react_1.default.createElement(icons_1.ShoppingOutlined, null),
        },
        {
            label: react_1.default.createElement(react_router_dom_1.Link, { to: "/admin/contacts" }, "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B"),
            key: '/admin/contacts',
            icon: react_1.default.createElement(icons_1.ContactsOutlined, null),
        },
        {
            label: react_1.default.createElement(react_router_dom_1.Link, { to: "/admin/About" }, "\u041E \u043D\u0430\u0441"),
            key: '/admin/about',
            icon: react_1.default.createElement(icons_1.InfoCircleOutlined, null),
        },
        {
            label: react_1.default.createElement(react_router_dom_1.Link, { to: "/admin/banners" }, "\u0411\u0430\u043D\u043D\u0435\u0440\u044B"),
            key: '/admin/banners',
            icon: react_1.default.createElement(icons_1.RobotOutlined, null),
        },
        {
            label: react_1.default.createElement(react_router_dom_1.Link, { to: "/admin/catalog" }, "\u041A\u0430\u0442\u0430\u043B\u043E\u0433"),
            key: '/admin/catalog',
            icon: react_1.default.createElement(icons_1.RobotOutlined, null),
        },
        {
            label: react_1.default.createElement(react_router_dom_1.Link, { to: "/admin/add_catalog" }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0430\u0432\u0442\u043E \u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0433"),
            key: '/admin/add_catalog',
            icon: react_1.default.createElement(icons_1.PlusCircleOutlined, null),
        },
        {
            label: 'Выход',
            key: 'logout',
            icon: react_1.default.createElement(icons_1.LogoutOutlined, null),
            danger: true,
            style: { marginLeft: 'auto' },
        },
    ];
    var onClick = function (e) {
        if (e.key === 'logout') {
            dispatch((0, adminSlice_1.setAuth)(false));
            sessionStorage.removeItem('isAuth');
            return;
        }
        navigate(e.key);
    };
    return (react_1.default.createElement(antd_1.Layout, { className: Layout_module_scss_1.default.layout },
        react_1.default.createElement(Header, { className: Layout_module_scss_1.default.header },
            react_1.default.createElement("div", { className: Layout_module_scss_1.default.logo }, "ADMIN PANEL"),
            react_1.default.createElement(menu_1.default, { theme: "dark", mode: "horizontal", items: items, selectedKeys: [location.pathname], onClick: onClick, className: Layout_module_scss_1.default.menu })),
        react_1.default.createElement(Content, { className: Layout_module_scss_1.default.content },
            react_1.default.createElement(react_router_dom_1.Outlet, null))));
};
exports.Layout = Layout;
